/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Billing_Details_DescInputs */



/**
* | output |
* | --- |
* | "Used to calculate the VAT on your invoices." |
*
* @param {Sub_Billing_Details_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_billing_details_desc = /** @type {((inputs?: Sub_Billing_Details_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Billing_Details_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Grundlage für die Umsatzsteuer auf Ihren Rechnungen.")
	return /** @type {LocalizedString} */ ("Used to calculate the VAT on your invoices.")
});